import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import * as React from 'react';
import cn from 'classnames';
import { Enum } from '../../../library';
var messageGroupClasses = {
  base: 'messages'
};
export var MessageGroupSpacingType = Enum({
  COLLAPSE: 'collapse',
  COMPACT: 'compact',
  NORMAL: 'normal',
  RELAXED: 'relaxed'
});
export var MessageGroupContext = React.createContext({});
export var Messages = function Messages(props) {
  var children = props.children,
    className = props.className,
    passProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn(messageGroupClasses.base, _defineProperty({}, "-".concat(props.spacing), props.spacing !== 'normal'), className);
  return React.createElement(MessageGroupContext.Provider, {
    value: passProps
  }, React.createElement("div", {
    className: classNames,
    children: children
  }));
};
Messages.displayName = 'Messages';
Messages.defaultProps = {
  spacing: 'normal'
};